import React, { useContext, useEffect } from 'react';
import { Context } from '../../../context/global-data-provider';

import Header from '../../containers/header/header';
import PostsList from '../../containers/posts-list/posts-list';

function Home() {
  const { options, deletedPostManager, setCurrentRoute } = useContext(Context);

  useEffect(() => {
    setCurrentRoute('/');
    document.title = options.title;

    deletedPostManager.setPart('home');
  }, []);

  return (
    <React.Fragment>
      <Header />
      <PostsList />
    </React.Fragment>
  );
}

export default Home;
